import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactoService {
  constructor(private http: HttpClient) {}

  postContacto(contacto: Object) {
    return this.http.post(environment.baseUrl + '/contacto/', contacto);
  }
}
